import { z } from 'zod';
import {
  employeePathSchema,
  employeesSearchSchema,
} from 'src/modules/automations/schemas/employees/employees.schema';

/**
 * Schema for validating search parameters in the executions list view.
 * Extends the employees search schema with no additional parameters.
 */
export const executionsSearchSchema = employeesSearchSchema.merge(
  z.object({
    // Persisted calendar-date filters (YYYY-MM-DD). Legacy ISO values are normalized by the page adapter.
    from: z.string().optional(),
    to: z.string().optional(),
  })
);
/**
 * Type definition for the executions search parameters.
 */
export type ExecutionsSearch = z.infer<typeof executionsSearchSchema>;

/**
 * Schema for validating URL path parameters when accessing the executions list view.
 * Extends the employee path schema and requires a valid employeeId string.
 */
export const executionsPathSchema = employeePathSchema.merge(z.object({}));
/**
 * Type definition for executions path parameters.
 */
export type ExecutionsPath = z.infer<typeof executionsPathSchema>;

/**
 * Schema for validating search parameters in the execution detail view.
 * Extends the employees search schema with no additional parameters.
 */
export const executionSearchSchema = employeesSearchSchema.merge(
  z.object({
    // Carry date filters when navigating into details and back
    from: z.string().optional(),
    to: z.string().optional(),
  })
);
/**
 * Type definition for the execution search parameters.
 */
export type ExecutionSearch = z.infer<typeof executionSearchSchema>;

/**
 * Schema for validating URL path parameters when accessing a specific execution.
 * Extends the employee path schema and requires a valid executionId string.
 */
export const executionPathSchema = employeePathSchema.merge(
  z.object({
    executionId: z.string(),
  })
);
/**
 * Type definition for execution path parameters.
 */
export type ExecutionPath = z.infer<typeof executionPathSchema>;
